import React from 'react'

function BabyMom() {
  return (
    <div>
      <button className='peer text-white lg:text-gray-700 font-semibold lg:font-normal text-center   text-md   lg:text-sm'  >Bebek & Anne</button>
      <div className='hidden peer-hover:flex hover:flex absolute'>
        <div className='p-2 md:p-3 lg:p-4 z-20 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 border border-gray-400 lg:border-none  mt-2 lg:mt-6 cursor-pointer  w-80 md:w-97 lg:w-98 text-center'>
            <div className='p-1 lg:p-2 space-x-2  grid grid-cols-2 md:grid-cols-5'>
                <ul className='space-y-1 text-gray-700  font-[500] mt-2 text-xs  md:text-sm' >
                    <h6 className=' font-500 text-gray-300 underline'>Bebek</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Elbiseleri</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Ayakkabı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Takımları</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Zıppın & Body</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Patik</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Maması</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Bezi</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Yenidoğan Kıyafet</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Montları</li>
                </ul>

                <ul className='space-y-1 text-gray-700  font-[500] mt-2 text-xs  md:text-sm' >
                    <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Bebek Beslenme</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Mama Sandalyesi</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Mama Önlük</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Takımları</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Biberon</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Emzik</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Alıştırma Bardağı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Termal Mama Çantası</li>
            
                </ul>
                
                <ul className='space-y-1 text-gray-700  font-[500] mt-2 text-xs  md:text-sm' >
                    <h6 className=' font-500 text-gray-300 underline'>Bebek Bakım</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Tuvalet</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Banyo</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Şampuanı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Sabunu</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Çantası</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Küvet Filesi</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Krem</li>
            
                </ul>
                <ul className='space-y-1 text-gray-700  font-[500] mt-2 text-xs  md:text-sm' >
                    <h6 className=' font-500 text-gray-300 underline'>Bebek Taşıma</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Puset</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Arabası</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Oto Koltuk</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Yürüteç</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Park Yatak</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Küvet Filesi</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Portbebe</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bebek Bisikletleri</li>
            
                </ul>
                <ul className='space-y-1 text-gray-700  font-[500] mt-2 text-xs  md:text-sm' >
                    <h6 className=' font-500 text-gray-300 underline'>Bebek Oyuncak</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Banyo Oyuncakları</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Oyuncak Arabalar</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Oyuncak Bebekler</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Oyun Hamuru</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Pluş Oyuncaklar</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Eğitici Oyuncaklar</li>
                    
            
                </ul>
            </div>
        </div>
      </div>

    </div>
  )
}

export default BabyMom
